import React from 'react'
import VirtualCards from 'src/app/VirtualCards/VirtualCards'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import VirtualCardsAllCardsAppRoute from 'src/navigation/appRoutes/virtualCards/virtualCardsAllCards.appRoute'
import VirtualCardsNeedsApprovalAppRoute from 'src/navigation/appRoutes/virtualCards/virtualCardsNeedsApproval.appRoute'
import VirtualCardsRequestsAppRoute from 'src/navigation/appRoutes/virtualCards/virtualCardsRequests.appRoute'
import { virtualCardsRouteProps } from 'src/navigation/routeProps'

const VirtualCardsAppRoute: AppRoute = {
  id: AppLocation.VirtualCards,
  routeProps: virtualCardsRouteProps,
  component: <VirtualCards />,
  subRoutes: [
    VirtualCardsAllCardsAppRoute,
    VirtualCardsRequestsAppRoute,
    VirtualCardsNeedsApprovalAppRoute,
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default VirtualCardsAppRoute
